import { Fragment, memo, useState } from 'react';
import { IconButton, Checkbox } from '@material-ui/core';
import { DragIcon, HideIcon, DocumentFileIcon } from '@room-match/shared-ui-components';
import { MediaItemWrapper } from 'pages/Representatives/components/MediaItemCommon.styles';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { EditProfileCustomSkeleton, EditProfileNumberBox } from '../../../EditProfile.styles';
import { EttachedHiddenType } from 'shared/enums/EAttachedHiddenType';
import { goToLink } from 'shared/utils/goToLink';
import { useEditProfileDndControls } from '../../../hooks/useEditProfileDndControls';
import { EditProfileMediaCheckBoxContainer } from '../../EditProfileMedia/EditProfileMedia.styles';

type EditProfileMediaDocumentsDocumentItemProps = {
  url: string;
  fileName: string;
  id: string;
  index?: number;
  type: EttachedHiddenType;
  onHideClick?: VoidFunction;
};

const EditProfileMediaDocumentsDocumentItem = ({
  url,
  fileName,
  id,
  index,
  type = EttachedHiddenType.ATTACHED,
  onHideClick,
}: EditProfileMediaDocumentsDocumentItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const isOptmisicallyUpdating = fileName?.includes('skeleton-optimistic-updating-list');
  const { attributes, listeners, style, setNodeRef } = useEditProfileDndControls(id);

  const sortAbleProps =
    EttachedHiddenType.HIDDEN === type || isOptmisicallyUpdating
      ? {}
      : {
          container: {
            ref: setNodeRef,
          },
          item: {
            ...attributes,
            ...listeners,
          },
        };

  return (
    <MediaItemWrapper
      onClick={() => {
        goToLink(url);
        console.log(url);
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...sortAbleProps.container}
      style={style}
    >
      {isOptmisicallyUpdating ? (
        <Fragment>
          <p></p>
          <EditProfileCustomSkeleton variant="rect" width={'100%'} />
        </Fragment>
      ) : (
        <Fragment>
          <IconButton style={{ padding: 0 }}>
            {type === EttachedHiddenType.ATTACHED && isHovered ? (
              <DragIcon style={{ cursor: 'move' }} {...sortAbleProps.item} />
            ) : (
              <DocumentFileIcon />
            )}
          </IconButton>
          <div style={{ display: 'grid' }}>
            <div style={{ overflow: 'hidden' }}>
              <TypographyTooltip variant="subtitle1">{fileName}</TypographyTooltip>
            </div>
          </div>
        </Fragment>
      )}
      <EditProfileNumberBox
        style={{ position: 'unset', ...(type === EttachedHiddenType.HIDDEN && { background: 'unset' }) }}
      >
        {type === EttachedHiddenType.ATTACHED && isHovered && !isOptmisicallyUpdating ? (
          <IconButton
            style={{ padding: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              if (onHideClick) onHideClick();
            }}
          >
            <HideIcon />
          </IconButton>
        ) : type === EttachedHiddenType.HIDDEN ? (
          <EditProfileMediaCheckBoxContainer
            onClick={(e) => {
              e.stopPropagation();
              if (onHideClick) onHideClick();
            }}
          >
            <Checkbox checked={false} />
          </EditProfileMediaCheckBoxContainer>
        ) : (
          index
        )}
      </EditProfileNumberBox>
    </MediaItemWrapper>
  );
};

export default memo(EditProfileMediaDocumentsDocumentItem);
